/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    // Custom open mobile menu items
    if(document.querySelector('.custom-mobile-menu')) {
        let mobileMenuContainer = document.querySelector('.custom-mobile-menu .menu__items');
        let mobileMenuItes = document.querySelectorAll('.custom-mobile-menu .menu__item');
        let mobileMenuItem = document.querySelectorAll('.custom-mobile-menu .menu__item:not(.child) > a');
        let mobileMenuItemLink = document.querySelectorAll('.custom-mobile-menu .menu__item .navlink');
        let mobileMenuItemClose = document.querySelectorAll('.mobile-menu-close');
    
        mobileMenuItem.forEach((item)=>{
            item.addEventListener('click', (e)=>{
                e.preventDefault();

                mobileMenuContainer.classList.remove('is-active');
                mobileMenuItes.forEach((item)=>{
                    item.classList.remove('is-active');
                })

                if(item.classList.contains('is-active')) {
                    item.classList.remove('is-active');
                    item.closest('.menu__items').classList.remove('is-active');
                    item.closest('.menu__item').classList.remove('is-active');
    
                } else {
                    item.classList.add('is-active');
                    item.closest('.menu__items').classList.add('is-active');
                    item.closest('.menu__item').classList.add('is-active');
                }
            })
        })
    
        mobileMenuItemClose.forEach((item)=>{
            item.addEventListener('click', (e)=>{
                mobileMenuContainer.classList.remove('is-active');
                mobileMenuItes.forEach((item)=>{
                    item.classList.remove('is-active');
                })
                mobileMenuItem.forEach((item)=>{
                    item.classList.remove('is-active');
                })
            })
        })
        
    }


    // Anchor functionality for Listing accessories page
    let searchListingPageOptions = document.querySelectorAll('.image-with-text-selector section');
    let sectionAnchor = document.querySelector('.custom-select--search select');
// UPDATED VERSION CODE BELOW 


  if (sectionAnchor && searchListingPageOptions) {



 searchListingPageOptions.forEach((item) => {
    let title = item.dataset.title;
    let formattedTitle = item.dataset.formattedtitle;

    // ── Skip if no valid data attributes ──
    if (!formattedTitle || !title || formattedTitle === 'undefined') return;

    const option = document.createElement('option');
    option.value = formattedTitle;
    option.textContent = title;
    sectionAnchor.appendChild(option);
});

    // ── Manually add EZY MOTION option ──
    const ezyOption = document.createElement('option');
    ezyOption.value = 'ezy-motion';
    ezyOption.textContent = 'EZY Motion';
    sectionAnchor.appendChild(ezyOption);
    // ── End manual option ──

      sectionAnchor.addEventListener('change', () => {
    let id = sectionAnchor.value;
    let target;

    // ── EZY MOTION manual scroll by section ID ──
    if (id === 'ezy-motion') {
        target = document.getElementById('ImageWithText--template--26783348621617__section_image_with_text_XjJkrV');
        if (target) {
            history.replaceState(null, null, '#ezy-motion');
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
    }
    // ── End EZY MOTION ──

    if (id) {
        history.replaceState(null, null, `#${id}`);
        target = document.querySelector(`.image-with-text-selector [data-formattedtitle="${id}"]`);
    }
    if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
});
    }
    // if (sectionAnchor && searchListingPageOptions) {
    //     searchListingPageOptions.forEach((item) => {
    //         let title = item.dataset.title;
    //         let formattedTitle = item.dataset.formattedtitle;
    //         const option = document.createElement('option');
    //         option.value = formattedTitle;
    //         option.textContent = title;
    //         sectionAnchor.appendChild(option);
    //     });

    //     sectionAnchor.addEventListener('change', () => {
    //         let id = sectionAnchor.value;
    //         let target;
    //         if (id) {
    //             // Update URL hash
    //             history.replaceState(null, null, `#${id}`);
    //             target = document.querySelector(`.image-with-text-selector [data-formattedtitle="${id}"]`);
    //         }
    //         if (target) {
    //             target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //         }
    //     });
    // }

    // Scroll to section if URL contains a hash
    document.addEventListener('DOMContentLoaded', () => {
        const hash = window.location.hash.substring(1); // Remove the #
        if (hash) {
            const target = document.querySelector(`.image-with-text-selector [data-formattedtitle="${hash}"]`);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });

                // Optional: preselect the dropdown
                if (sectionAnchor) {
                    sectionAnchor.value = hash;
                }
            }
        }
    });


    /*if (document.querySelector('.home-hero-mobile')) {
    window.addEventListener('scroll', function() {
            const block = document.querySelector('.home-hero-mobile');
            const blockItems = document.querySelector('.home-hero-mobile .banner-image__buttons');
            const blockRect = block.getBoundingClientRect();
            if (blockRect.top  <= 0) {
                blockItems.classList.add('is-active');
            } else {
                blockItems.classList.remove('is-active');
            }
        });
    }*/

    if (document.querySelector('.video-wrapper .video-text-link')) {
        const videoButton = document.querySelectorAll('.video-wrapper .video-text-link');
        videoButton.forEach((item)=>{

            item.addEventListener('click', function(e) {
                e.preventDefault();
                let video = this.closest('.video-wrapper');

                if(video.classList.contains('is-paused')) {
                    video.classList.remove('is-paused');
                } else {
                    video.classList.add('is-paused');
                }
            });
        })
    }

    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {    
        if (links[i].hostname !== window.location.hostname) {
             links[i].target = "_blank";        links[i].rel = "noreferrer noopener";
        }
    }


    /* --- MOVINGLIFE ISRAEL ARTICLE TOC INTERACTIVITY & SCROLL SPY --- */
    (function() {
    function initMovingLifeToc() {
        const articleWrapper = document.querySelector('.movinglife-article-wrapper');
        const stickyToc = document.querySelector('.ml-toc-sticky-container');
        const topTocBox = document.querySelector('.us-top-toc-box');

        if (!articleWrapper || !stickyToc) return;

        // 🌟 התיקון הקריטי: הוצאת ה-TOC הצף ישירות ל-BODY כדי שהאנימציות של Theme לא ישברו את ה-position:fixed
        document.body.appendChild(stickyToc);

        // 1. הופעה/העלמה של ה-TOC הצף בגלילה
        window.addEventListener('scroll', function() {
        const topTocBottom = topTocBox ? (topTocBox.offsetTop + topTocBox.offsetHeight) : 300;
        if (window.scrollY > topTocBottom) {
            stickyToc.classList.add('ml-show-sidebar');
        } else {
            stickyToc.classList.remove('ml-show-sidebar');
        }
        });

        // 2. כפתור פתיחה/כיווץ של ה-TOC הצף
        const tocHeader = stickyToc.querySelector('.ml-toc-header');
        if (tocHeader) {
        tocHeader.addEventListener('click', function() {
            stickyToc.classList.toggle('ml-collapsed');
        });
        }

        // 3. גלילה רכה (Smooth Scroll) לכל קישורי ה-TOC
        const allTocLinks = document.querySelectorAll('.us-top-toc-list a, .ml-toc-link');
        allTocLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');
            if (targetId && targetId.startsWith('#')) {
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                e.preventDefault();
                targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
                });
            }
            }
        });
        });

        // 4. עדכון הקישור הפעיל בזמן גלילה (Active Scroll Spy)
        const headings = Array.from(articleWrapper.querySelectorAll('h2[id]'));
        const stickyTocLinks = stickyToc.querySelectorAll('.ml-toc-link');

        if (headings.length > 0 && stickyTocLinks.length > 0) {
        window.addEventListener('scroll', function() {
            let currentId = '';
            const scrollPosition = window.scrollY + 150;

            headings.forEach(function(heading) {
            if (scrollPosition >= heading.offsetTop) {
                currentId = heading.getAttribute('id');
            }
            });

            stickyTocLinks.forEach(function(link) {
            link.classList.remove('active');
            if (currentId && link.getAttribute('href') === '#' + currentId) {
                link.classList.add('active');
            }
            });
        });
        }
    }

    // הפעלה בטוחה שתואמת לטעינת defer
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMovingLifeToc);
    } else {
        initMovingLifeToc();
    }
    })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

